import axios from 'axios';
import React, { useMemo, useState } from 'react'
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form } from 'reactstrap';
import { Label, Input } from 'reactstrap'
import { environment } from '../../env'; 1
import { Phone } from 'react-telephone';
import { loaderAction, successModalToggle } from '../../redux/actions/Index';
import ErrorComponents from '../errorComponents/ErrorComponents';
import { PencilLine } from '@phosphor-icons/react';

function AddPocModal({ investor, tenant, ttenant, data1, type, update }, ...props) {
    // List useState Here
    const [modal, setModal] = useState(false);
    const [btndis, setBtndis] = useState(false);
    const [contect, setContect] = useState();
    const [contecterr, setContecterr] = useState(false);
    const [editt, setEdit] = useState(true);
    const [phoneNumber, setPhoneNumber] = useState('');
    const toggle = () => setModal(!modal);

    //  redux Here
    const PocDesignationList = useSelector((state) => state?.ModalReducer?.pocdesnameslist);
    const dispatch = useDispatch();

    // useForm Here
    const {
        register,
        reset,
        handleSubmit,
        setValue,
        formState: { errors },
    } = useForm({ mode: "onChange" });

    const handelContactBlur = (number) => {
        setValue("poc_contact_number",number)
        setContecterr(false)
        if(number.length != 13){
            setContecterr(true)
        }
    };

    const submit = (data) => {
        if (data.poc_contact_number.length !== 13) {
            setContecterr(true)
            setBtndis(false)
            return;
        }
        setContecterr(false)
        const PocPayload = new FormData();
        PocPayload.append('tenant', tenant)
        PocPayload.append('poc_name', data.poc_name)
        PocPayload.append('poc_email', data.poc_email)
        PocPayload.append('poc_contact_number', data.poc_contact_number)
        PocPayload.append('poc_desigation', data.poc_desigation)
        PocPayload.append('poc_comment', data.poc_comment)

        dispatch(loaderAction())
        try {
            const PocURL = `${environment.baseUrl}add-tenant-poc/`;
            axios.post(PocURL, PocPayload).then((pocresponse) => {
                if (pocresponse.data.code === 200) {
                    dispatch(successModalToggle());
                    dispatch(loaderAction())
                    toggle();
                    reset();
                    setBtndis(false);
                } else {
                    dispatch(loaderAction())
                    setBtndis(false);
                }
            })
        } catch (err) {
            dispatch(loaderAction())
            setBtndis(false)

        }
    }

    const SubmitPOC = (data) => {
        setContecterr(false)
        if (data.poc_contact_number.length !== 13) {
            setContecterr(true)
            setBtndis(false)
            return;
        }
        const PocPayload = new FormData();
        PocPayload.append('investor', investor)
        PocPayload.append('poc_name', data.poc_name)
        PocPayload.append('poc_email', data.poc_email)
        PocPayload.append('poc_contact_number', data.poc_contact_number)
        PocPayload.append('poc_desigation', data.poc_desigation)
        PocPayload.append('poc_comment', data.poc_comment)

        dispatch(loaderAction())
        try {
            const PocURL = `${environment.baseUrl}add-poc/`;
            axios.post(PocURL, PocPayload).then((pocresponse) => {
                if (pocresponse.data.code === 200) {
                    dispatch(successModalToggle());
                    dispatch(loaderAction())
                    toggle();
                    reset();
                    setBtndis(false);
                } else {
                    dispatch(loaderAction())
                    setBtndis(false);

                }
            })
        } catch (err) {
            dispatch(loaderAction())
            setBtndis(false)

        }
    }

    const EditPOC = async (data) => {
        setContecterr(false)
        if (data.poc_contact_number.length !== 13) {
            setContecterr(true)
            setBtndis(false)
            return;
        }
        const PocPayload = new FormData();
        PocPayload.append('investor', data.investor)
        PocPayload.append('poc_name', data.poc_name)
        PocPayload.append('poc_email', data.poc_email)
        PocPayload.append('poc_contact_number', data.poc_contact_number)
        PocPayload.append('poc_desigation', data.poc_desigation)
        PocPayload.append('poc_comment', data.poc_comment)

        dispatch(loaderAction())
        try {
            const PocURL = `${environment.baseUrl}investor-poc/${data1.id}`;
            await axios.put(PocURL, PocPayload).then((pocresponse) => {
                if (pocresponse.data.code === 200) {
                    dispatch(successModalToggle());
                    dispatch(loaderAction())
                    toggle();
                    reset();
                    update(true)
                    setBtndis(false);
                } else {
                    dispatch(loaderAction())
                    setBtndis(false);

                }
            })
        } catch (err) {
            dispatch(loaderAction())
            setBtndis(false)
        }
    }

    const CancelButtonsw = () => {
        toggle();
        reset();
        setContect()
        setContecterr()
        setBtndis(false);
    }

    useMemo(() => {
        reset(
            {
                "investor": data1?.investor,
                "poc_name": data1?.poc_name,
                "poc_email": data1?.poc_email,
                "poc_contact_number": data1?.poc_contact_number,
                "poc_desigation": data1?.poc_desigation,
                "poc_comment": data1?.poc_comment,
            },
        );

        setPhoneNumber(data1?.poc_contact_number)
    }, [editt])

    return (
        <>
            {type == 'edit' ? (
                <button
                    onClick={() => { setModal(!modal); setEdit(!editt) }}
                    className="icon-bg-yellow border-0 px-2 py-3 rounded"><PencilLine size="28" className='icon-color-yellow' />
                </button>
            ) : (
                <Button onClick={toggle} className='border-radius-7 px-3 d-flex align-items-center buttons py-3 flex-nowrap'><span className='fs-4 d-flex gap-3 title-font-600 ps-3 pe-4 '> POC </span></Button>
            )}

            <Modal className='border-0' isOpen={modal} size="md" centered>
                <ModalHeader className='bg-base-color '><span className='title-font-700 fs-36 text-base-white'>{type == 'edit' ? 'Edit POC' : 'Add POC'}</span></ModalHeader>
                <Form onSubmit={
                    type == 'edit' ?
                        handleSubmit(EditPOC) :
                        ttenant == false ?
                            handleSubmit(SubmitPOC) :
                            handleSubmit(submit)
                }>
                    <ModalBody className='bg-background-color px-5'>
                        <div className="row">
                            <div className='col-12 mx-auto mx-md-0  pb-3 pt-1'>
                                <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                    POC Names *
                                </Label>
                                <br />
                                <div className='mt-1  d-flex gap-3'>
                                    <input
                                        className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='text'
                                        placeholder='Enter POC Name...'
                                        {...register("poc_name", {
                                            required: ' POC Name is required *', pattern: {
                                                value: /^[a-zA-Z ]+$/,
                                                message: "Enter characters only"
                                            }
                                        })}
                                    />
                                </div>
                                {errors.poc_name && <ErrorComponents error={errors.poc_name.message} />}
                                <br />
                            </div>
                            <div className='col-12 mx-auto mx-md-0  pb-3 pt-1'>
                                <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                    POC Contact *
                                </Label>
                                <br />
                                <div className='mt-1  d-flex gap-3'>
                                    <Phone {...register('poc_contact_number', { required: 'Contact No. Required'})} onChange={(e) => (handelContactBlur(e.target.value))} defaultCountry="in" value={phoneNumber} className='d-flex border-radius-10 shadow-none px-4  w-100 fs-4 title-font-500 fs-2 modal-input bg-white py-3'>
                                        <Phone.Country className='fs-4 border-0 w-25 border-end' />
                                        <Phone.Number placeholder="1234567890" className=' ps-2 w-75 fs-4 title-font-500  border-0' />
                                    </Phone>
                                </div>

                                {(contecterr || errors.poc_contact_number) && <ErrorComponents error={"Enter valid contact Number."} />}
                                <br />
                            </div>
                            <div className='col-12 mx-auto mx-md-0  pb-3 pt-1'>
                                <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                    POC Designation *
                                </Label>
                                <br />
                                <div className='mt-1  d-flex gap-3'>
                                    <select
                                        id="poc_desigation"
                                        name="poc_desigation"
                                        className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                        {...register("poc_desigation", { required: 'Please select Designation' })}
                                    >
                                        <option value="">Select Designation</option>
                                        {PocDesignationList?.map((data, i) => {
                                            return <option value={data.name} key={i}>{data.name}</option>;
                                        })}
                                    </select>
                                </div>
                                {errors.poc_desigation && <ErrorComponents error={errors.poc_desigation.message} />}
                                <br />
                            </div>
                            <div className='col-12 mx-auto mx-md-0  pb-3 pt-1'>
                                <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                    POC Email *
                                </Label>
                                <br />
                                <div className='mt-1  d-flex gap-3'>
                                    <input
                                        className='p-3  border-radius-10 shadow-none text-lowercase  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='email'

                                        placeholder='Enter POC Email...'
                                        {...register("poc_email", {
                                            required: ' POC Email is required *', pattern: {
                                                value: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
                                                message: "Enter valid email"
                                            }
                                        })}
                                    />
                                </div>
                                {errors.poc_email && <ErrorComponents error={errors?.poc_email?.message} />}
                                <br />
                            </div>
                            <div className='col-12 mx-auto mx-md-0  pb-3 pt-1'>
                                <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                    POC Comments *
                                </Label>
                                <br />
                                <div className='mt-1  d-flex gap-3'>
                                    <textarea
                                        className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        placeholder='Enter  Comments...'
                                        {...register("poc_comment", { required: true })}
                                    ></textarea>
                                </div>
                                {errors.poc_comment && <ErrorComponents error={' POC Comments is required *'} />}
                                <br />
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter className='d-flex justify-content-end align-items-center px-4'>
                        <div className="d-flex justify-content-between align-items-center gap-3">
                            <Button type='button' className='border-radius-7 p-3 d-flex align-items-center buttons-outline' onClick={CancelButtonsw}><span className='fs-4 d-flex gap-3 title-font-600 px-3' >Cancel</span></Button>
                            <Button className='border-radius-7 p-3 d-flex align-items-center buttons' disabled={btndis}><span className='fs-4 d-flex gap-3 title-font-600 px-3'>{type == 'edit' ? 'Edit POC' : 'Add POC'}</span></Button>
                        </div>
                    </ModalFooter>
                </Form>
            </Modal>
        </>
    )
};


export default AddPocModal